import { useTranslation } from 'react-i18next';
import FieldPathInput from '../components/FieldPathInput.tsx';
import { useActionUpdate } from '../hooks/useActionUpdate.ts';
import type { ExtractSourceAction, AliasContextEntry } from '../types.ts';

interface ExtractSourceBlockProps {
    action: ExtractSourceAction;
    mappingIndex: number;
    actionIndex: number;
    aliasContext?: AliasContextEntry[];
    onUpdate?: (updates: Partial<ExtractSourceAction>) => void;
}

const ExtractSourceBlock = ({
    action,
    mappingIndex,
    actionIndex,
    aliasContext = [],
    onUpdate,
}: ExtractSourceBlockProps) => {
    const { t } = useTranslation('integrations');
    const handleUpdate = useActionUpdate<ExtractSourceAction>(mappingIndex, actionIndex, onUpdate);

    return (
        <div className="flex flex-col gap-2">
            <label className="text-xs text-content-weak">{t('outputMapper.visualEditor.sourceField')}</label>
            <FieldPathInput
                value={action.source}
                onChange={(source) => handleUpdate({ source })}
                aliasContext={aliasContext}
                includeChainValue={false}
                placeholder={t('outputMapper.visualEditor.selectSourceField')}
            />
        </div>
    );
};

export default ExtractSourceBlock;
